import { MapBuilder, px, type Decor, type MapDef } from '../mapdef';

/** The family flat: bathroom, open kitchen, living room, your bedroom and your sister's play corner. */
const b = new MapBuilder(24, 17, ' ');
b.room(0, 0, 24, 17, '.');
b.room(0, 0, 7, 8, 'b'); // bathroom
b.room(16, 0, 8, 8, ':'); // bedroom
b.fill(7, 1, 9, 5, 'k'); // kitchen
b.set(3, 7, 'd').set(4, 7, 'd');
b.fill(19, 7, 2, 1, 'd');
b.fill(11, 16, 2, 1, 'D');
b.set(23, 12, 'D'); // balcony door
b.fill(8, 10, 6, 3, ':'); // living-room rug
b.fill(18, 10, 4, 3, ';'); // play mat

const at = (tx: number, ty: number) => ({ x: px(tx), y: px(ty) });
const box = (tx: number, ty: number, tw: number, h = 10): Decor['solid'] => ({ x: px(tx) + 1, y: px(ty) - h, w: px(tw) - 2, h });

const decor: Decor[] = [
  { kind: 'window', x: px(9), y: 0, w: px(3), wall: true },
  { kind: 'window', x: px(18), y: 0, w: px(2), wall: true },
  { kind: 'clock', x: px(14), y: 2, wall: true },
  { kind: 'curtain', x: px(1), y: px(7) + 2, wall: true },
  { kind: 'painting', x: px(8), y: px(7) + 3, wall: true, variant: 2 },
  { kind: 'diningTable', ...at(11, 6), solid: box(9.5, 6, 3, 10) },
  { kind: 'livingSofa', ...at(11, 14), solid: box(9, 14, 4, 10) },
  { kind: 'rugRound', ...at(11, 12) },
  { kind: 'wardrobe', ...at(22.5, 6), solid: box(22, 6, 1, 12) },
  { kind: 'bookshelfHome', ...at(1.5, 12), solid: box(1, 12, 1, 10) },
  { kind: 'toyBox', ...at(21.5, 14), solid: box(21, 14, 1, 8) },
  { kind: 'pottedPlant', x: px(15) + 8, y: px(9) + 12, solid: { x: px(15) + 2, y: px(9) + 6, w: 12, h: 6 } },
  { kind: 'sinkRow', ...at(5, 6), w: px(1), solid: box(4.5, 6, 1, 8) },
];

export const home: MapDef = {
  id: 'home',
  w: b.w,
  h: b.h,
  rows: b.rows(),
  indoor: true,
  theme: { wallFace: '#f1d9b5', wallLight: '#f9e8cc', wainscot: '#b07a52', wallTop: '#3a2418' },
  doors: [
    { tiles: [[11, 16], [12, 16]], to: 'town', arrive: { x: px(29), y: px(55), facing: 'down' } },
    { tiles: [[23, 12]], to: 'balcony', arrive: { x: px(1) + 10, y: px(3) + 8, facing: 'right' } },
  ],
  decor,
  areas: [{ key: 'home', rect: { x: 0, y: 0, w: px(24), h: px(17) } }],
  lights: [
    { x: px(11), y: px(11), r: 120, color: '255,200,120' },
    { x: px(11), y: px(3), r: 90, color: '255,215,150' },
    { x: px(19), y: px(3), r: 70, color: '255,190,120' },
    { x: px(3), y: px(3), r: 60, color: '240,248,255' },
    { x: px(20), y: px(12), r: 70, color: '255,200,140' },
  ],
};
